import type { SVGProps } from 'react'
const SvgSyMenu = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" width={24} height={24} {...props}>
		<path d="M27.4 28.9h21.3v-7.3H14.8L27.9 8.4l-5.2-5.2-1.3 1.3L4.6 21.3.7 25.2l3.9 3.9 18.1 18.1 5.2-5.1-13.1-13.2h10.7z" />
		<path fillOpacity={0.24} d="M32.3 35.8h16.4v7.3H32.3zm0-28.2h16.4v7.3H32.3z" />
	</svg>
)
export default SvgSyMenu
